<template>
  <div id="root-contents" class="root-contents">
    <div class="background"></div>
    <PageIndexTop />
    <Header ref="header" @open-text-modal="openTextModal" />
    <!-- 言語セレクタ -->
    <LangSelect
      v-if="!isSP"
      class="lang-select"
      :class="{ '-active': isLangSelectActive }"
    />
    <PageIndexAbout />
    <PageIndexStay />
    <PageIndexFood />
    <PageIndexCafe />
    <PageIndexAccess />
    <PageIndexReserve />
    <PageIndexFaq />
    <PageIndexContact />
    <Footer :is-main="true" @open-text-modal="openTextModal" />
  </div>
</template>
<script setup lang="ts">
import {
  getPrivacyPolicy,
  getTermsOfUse,
  textModalCategory,
  type textModalType,
  type useStateTextModalType,
} from '~/models/TextModal'
import { setTextModal } from '~/models/useTextModal'
import { useMounted, useWindowSize } from "@vueuse/core";
import { useStructuredData } from '~/composables/useSeo'
const { locale } = useI18n()
const { isLangSelectActive } = useUtil()

definePageMeta({
  layout: 'top',
})

// 構造化データ（JSON-LD）
useStructuredData('top')

const isMounted = useMounted()
// SP表示かどうか
const { width } = useWindowSize()
const isSP = computed(() => {
  if (!isMounted.value) return true
  return width.value <= 767
});

const openTextModal = (textModalCategoryData: textModalCategory, ) => {
  let opentextModalData: textModalType
  switch (textModalCategoryData) {
    case textModalCategory.privacyPolicy:
      opentextModalData = getPrivacyPolicy(locale.value)
      break
    case textModalCategory.teamOfUse:
      opentextModalData = getTermsOfUse(locale.value)
      break
  }
  const useStateTextModalData: useStateTextModalType = {
    textModal: opentextModalData,
    show: true,
  }
  setTextModal(useStateTextModalData)
}
</script>

<style lang="scss" scoped>
@use '@/assets/styles/mixins' as m;
@use '@/assets/styles/variables' as v;

.root-contents {
  display: flex;
  flex-flow: column;
  width: 100%;
  height: 100%;
  overflow-x: clip;

  .background {
    position: fixed;
    inset: 0;
    background-image: url('~/assets/pages/common/BgOverall.webp');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    min-height: 100vh;
    width: 100%;
    z-index: v.$zindex-background;
  }

  /* 言語選択 */
  .lang-select {
    position: sticky;
    top: 90px;
    transition: 0.3s opacity ease-out;
    opacity: 0;
    pointer-events: none;
    cursor: auto;
    margin: 0 8px 0 auto;
    z-index: v.$zindex-lang-select;

    &.-active {
      opacity: 1;
      pointer-events: auto;
      cursor: pointer;
    }
  }
}
</style>
